import React, { useState, useEffect, useMemo } from 'react';
import { Header } from '../components/Header';
import Silk from '../components/Silk';
import { useParams } from 'react-router-dom';
import { CryptoCardsSection } from '../components/CryptoCards';
import {PolymarketCard} from '../components/polymarkets_card'
//import { NewsCardsSection } from '../components/NewsCards_Real';
import { useCryptoTop } from '../components/useCrypto'; // Use real crypto data hook
import { CryptoTreemap } from '../components/treemap_crypto';
import BitmexOrderBook from '../components/BitmexOrderBook'; // Import the new component
import { CorporateBTCTreasuryCard  } from '../components/CorporateBTCTreasuryCard';

// --- MAIN PAGE ---
export default function CryptoPage() {
  const { symbol } = useParams();
  const [isDark, setIsDark] = useState(true);
  
  // Use real crypto data from your API
  const { data: cryptoData, loading } = useCryptoTop();

  // Debug: Log the actual data structure from your API
  useEffect(() => {
    if (cryptoData) {
      console.log('🪙 Crypto API Response:', cryptoData);
      if (cryptoData.length > 0) {
        console.log('📊 First coin sample:', cryptoData[0]);
      }
    }
  }, [cryptoData]);

  const theme = {
    background: isDark ? '#080808' : '#f9fafb',
    textPrimary: isDark ? '#fff' : '#111827',
    textSecondary: isDark ? '#9ca3af' : '#6b7280',
    border: isDark ? 'rgba(255, 255, 255, 0.08)' : 'rgba(0, 0, 0, 0.1)',
    borderHover: isDark ? 'rgba(255, 255, 255, 0.12)' : 'rgba(0, 0, 0, 0.05)',
    cardBg: isDark ? 'rgba(20, 20, 20, 0.7)' : 'rgba(255, 255, 255, 0.9)',
    tickerBg: isDark ? 'rgba(0,0,0,0.4)' : 'rgba(248, 250, 252, 0.9)',
  };

  // Format crypto data for the Header ticker (same format as MarketOverviewPage)
  const getTopCryptoTickers = () => {
    if (!cryptoData || !Array.isArray(cryptoData)) return [];
    
    // IMPORTANT: Return raw numeric values, not formatted strings!
    // The Header component will format them itself
    return cryptoData.slice(0, 10).map(coin => ({
      ticker: coin.symbol,           // Ticker symbol
      name: coin.name,               // Full name
      ult: coin.price,               // Last price (numeric)
      var: coin.percent_change_24h   // Change percentage (numeric)
    }));
  };


  return (
    <div style={{ minHeight: '100vh', background: theme.background, color: theme.textPrimary, position: 'relative' }}>
      {/* Background — opacity 0.4 to match home page darkness */}
      <div style={{ position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', zIndex: 0, pointerEvents: 'none', opacity: 0.4 }}>
        <Silk speed={20} scale={1.2} color="#6660fe" noiseIntensity={2} />
      </div>

      <div style={{ position: 'relative', zIndex: 1 }}>
        <Header 
          theme={theme} 
          isDark={isDark} 
          toggleTheme={() => setIsDark(!isDark)} 
          topTickers={getTopCryptoTickers()}
          currency="USD"  // Tell Header to use $ instead of R$
        />

        <main style={{ maxWidth: '1400px', margin: '0 auto', padding: '4rem 2rem' }}>
          
          {/* Section Header */}
          <div style={{ marginBottom: '4rem' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '1rem', marginBottom: '1rem' }}>
              <h1 style={{ fontFamily: "'Roble', system-ui, sans-serif", fontSize: '3rem', fontWeight: 800, margin: 0, background: 'linear-gradient(to right, #007AFF, #00C7FF)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent' }}>
                Blockchain & Crypto
              </h1>
              <span style={{ fontFamily: "'IBM Plex Mono', monospace", background: 'rgba(0, 122, 255, 0.1)', color: '#007AFF', padding: '4px 12px', borderRadius: '100px', fontSize: '0.8rem', fontWeight: 'bold' }}>
                {loading ? 'LOADING...' : 'LIVE'}
              </span>
            </div>
            <p style={{ fontFamily: "'Plus Jakarta Sans', system-ui, sans-serif", fontWeight: 400, color: theme.textSecondary, fontSize: '1.2rem', maxWidth: '800px' }}>
              Monitoramento institucional de fluxos digitais, derivativos e mercados de previsão descentralizados.
            </p>
          </div>


    <div style={{ flex: '1 1 100%', marginBottom: '1.5rem' }}>
  <CorporateBTCTreasuryCard theme={theme} />
</div>

{/* Parent: Flex Row that wraps on small screens */}
<div style={{ 
  display: 'flex', 
  flexWrap: 'wrap',       // <--- The magic fix: allows items to drop to next line
  gap: '20px', 
  alignItems: 'flex-start',
  width: '100%' 
}}>
  
  
  {/* Left: OrderBook 
      flex: '1 1 340px' -> Grows at rate 1, Shrinks at rate 1, 
      Target width is 340px. If screen is narrower than ~850px, this wraps.
  */}
  <div style={{ flex: '1 1 340px' }}> 
    <BitmexOrderBook 
      symbol={symbol || 'BTC'} 
      theme={theme} 
      height="650px" 
    />
  </div>

  {/* Right: Treemap 
      flex: '2 1 500px' -> Grows 2x faster, Target width 500px.
  */}
  <div style={{ flex: '2 1 500px', display: 'flex' }}>
    <div style={{ width: '100%' }}>
      <CryptoTreemap theme={theme} />
    </div>
  </div>

</div>
          {loading ? (
            <div style={{ 
              fontFamily: "'Plus Jakarta Sans', system-ui, sans-serif",
              fontWeight: 400,
              textAlign: 'center', 
              padding: '4rem',
              color: theme.textSecondary 
            }}>
              <div style={{ fontSize: '2rem', marginBottom: '1rem' }}>⏳</div>
              <h3 style={{ fontFamily: "'Roble', system-ui, sans-serif", fontWeight: 800 }}>Carregando dados de criptomoedas...</h3>
              <p style={{ fontSize: '0.9rem', marginTop: '0.5rem' }}>
                Conectando a {process.env.REACT_APP_API_URL || '/api/py82'}
              </p>
            </div>
          ) : (
            <>
              {/* --- 🪙 CRYPTO & PREDICTION SECTION START --- */}
          

          {/* Visual Separator */}
          <div style={{ margin: '4rem 0', borderTop: `1px dashed ${theme.border}` }} />
          
          <section style={{ marginBottom: '3rem' }}>
            
          
            {/* Layout Grid */}
            <div style={{ 
              display: 'grid', 
              gridTemplateColumns: 'repeat(auto-fit, minmax(min(100%, 480px), 1fr))', 
              gap: '2rem' 
            }}>
              <PolymarketCard theme={theme}/>
              <CryptoCardsSection theme={theme} />
            </div>
          
          </section>
          
          {/* --- CRYPTO & PREDICTION SECTION END --- */}
          </>
          )}

        </main>
      </div>
    </div>
  );
}